import { IVariableOperationsGpsBonusSetup } from "@/PayPlans/types/sections/variableOperationsGpsBonus";
import { ESpiffTypes, IEligibilityRequirement } from "../../../types/spiffSetup";
import GpsContent from "./GPSCompliance/GpsContent";
import TargetedBonusContent from "./TargetedBonus/TargetedBonusContent";
import SalesContent from "./Sales/SalesContent";
import TradesContent from "./Trades/TradesContent";

interface IReadOnlyContentProps {
	spiffType: string;
	requirements: IEligibilityRequirement | IVariableOperationsGpsBonusSetup | string;
}

const ReadOnlyContent = (props: IReadOnlyContentProps) => {
	const { spiffType, requirements } = props;

	if (spiffType === ESpiffTypes.GPS_COMPLIANCE) {
		return <GpsContent spiffType={spiffType} requirements={requirements as IVariableOperationsGpsBonusSetup} />;
	} else if (spiffType === ESpiffTypes.DEPARTMENT || spiffType === ESpiffTypes.OP_CODES) {
		return <TargetedBonusContent spiffType={spiffType} requirements={requirements as IEligibilityRequirement} />;
	}

	const rules = typeof requirements === "object" ? (requirements as IEligibilityRequirement).rules : [];
	const tiers = typeof requirements === "object" ? (requirements as IEligibilityRequirement).tiers : [];
	const applyTiersRetroactively =
		typeof requirements === "object" ? (requirements as IEligibilityRequirement).applyTiersRetroactively : false;
	const informationMessage = applyTiersRetroactively ? "Tiers applied retroactively" : "";
	const verticalText = "Units";
	const commissionColumnsTitle = "Spiff";
	const pvrType = typeof requirements === "object" ? (requirements as IEligibilityRequirement).pvrType : "";
	const franchises = typeof requirements === "object" ? (requirements as IEligibilityRequirement).franchises : [];
	const requiredPvr = typeof requirements === "object" ? (requirements as IEligibilityRequirement).requiredPvr : undefined;
	const requiredStoreUnits = typeof requirements === "object" ? (requirements as IEligibilityRequirement).requiredStoreUnits : undefined;

	if (spiffType === ESpiffTypes.SALES) {
		return (
			<SalesContent
				rules={rules ?? []}
				tiers={tiers}
				tiersHeaderTitle={pvrType ?? ""}
				informationMessage={[
					informationMessage,
					requiredPvr ? `$${requiredPvr} PVR Required` : "",
					requiredStoreUnits ? `${requiredStoreUnits} Units Required` : "",
				]}
				verticalText={verticalText}
				commissionColumnsTitle={commissionColumnsTitle}
				franchises={franchises ?? []}
				spiffType={spiffType}
			/>
		);
	}

	return (
		<TradesContent
			tiers={tiers}
			tiersHeaderTitle={pvrType ?? ""}
			informationMessage={informationMessage}
			verticalText={verticalText}
			commissionColumnsTitle={commissionColumnsTitle}
			franchises={franchises ?? []}
			spiffType={spiffType}
		/>
	);
};

export default ReadOnlyContent;
